const Video = () => import('Modules/consulta/views/Video')
const Consulta = () => import('Modules/consulta/views/Consulta')

const rutas = [
  {
    name: 'confirmar_consulta',
    component: Consulta,
    path: '/confirmar/consulta/:id',
    props: {
      titulo: 'Ver',
      operacion: 'lectura'
    },
    meta: {
      requiresAuth: false,
      title: 'Ver',
      breadcrumb: null
    }
  },
  {
    name: 'acceder_consulta',
    component: Video,
    path: '/consulta/:perfil/:id',
    props: {
      titulo: 'Ver',
      operacion: 'lectura'
    },
    meta: {
      requiresAuth: false,
      title: 'Ver',
      breadcrumb: null
    }
  }
]

export default rutas
